import { useCurrentMembership } from './use-current-membership';

/** LOS MISMOS CARGOS QUE EXIGE EL SERVIDOR para tocar la estructura académica
 *  —programas, períodos, cursos y secciones—, que es `SECTION_MANAGEMENT_ROLES`
 *  en `apps/functions/src/lib/section-access.ts`.
 *
 *  ESTO NO ES LA SEGURIDAD, es la cortesía. Quien decide es el servidor; acá se
 *  evita ofrecerle a un docente un botón que va a responder «no tienes
 *  permiso». Un botón que falla es peor que un botón ausente: parece un error
 *  del sistema y no una decisión.
 *
 *  VIVE EN UN HOOK Y NO SUELTO EN CADA PÁGINA porque ya estaba escrito a mano
 *  en `term-detail.page.tsx` y era cuestión de tiempo que las copias
 *  divergieran de la lista del servidor. Un permiso escrito dos veces se
 *  desalinea igual que cualquier otra regla duplicada. */
export function useCanManageAcademics(): boolean {
  const membership = useCurrentMembership();
  const roles = membership?.roles ?? [];
  return (
    roles.includes('tenantAdmin') || roles.includes('registrar') || roles.includes('academicDean')
  );
}
